<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.fullPath)">
                <v-col cols="12">

                    <!-- employee detials   -->
                    <v-expansion-panels v-model="panel1">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4"  class="panel-header">Employee Details</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit" ref="addEmployee" id="addEmployee">
                                    
                                    <v-row class="pa-2">

                                        <v-col lg="4" md="4" cols="12">   
                                            
                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_id.value.value"
                                                :items="getHrmEmployeeList"
                                                :item-title="item => `${item.code}-${item.name}` ?? 'N/A'"
                                                item-value="id"
                                                @update:modelValue="onEmployeeChange"
                                                :error-messages="employee_id.errorMessage.value"
                                                :loading="loading"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Employee
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_name.value.value"
                                                :error-messages="employee_name.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                                disabled
                                            >
                                                <template #label>
                                                    Employee Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-autocomplete
                                                label="Department"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_department_id.value.value"
                                                :items="getHrmDepartmentList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="employee_department_id.errorMessage.value"
                                                :loading="loading"
                                                autocomplete="off"
                                                clearable
                                                disabled
                                            ></v-autocomplete>

                                        </v-col>
                                        
                                        <v-col lg="4" md="4" cols="12">
                                            <v-autocomplete
                                                label="Designation"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_designation_id.value.value"
                                                :items="getHrmDesignationList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="employee_designation_id.errorMessage.value"
                                                :loading="loading"
                                                autocomplete="off"
                                                clearable
                                                disabled
                                            >
                                            </v-autocomplete>

                                            <v-date-input
                                                label="Joining Date"
                                                prepend-inner-icon="mdi-calendar"
                                                prepend-icon=""
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_joining_date.value.value"
                                                :error-messages="employee_joining_date.errorMessage.value"
                                                autocomplete="off"
                                                input-format="dd/mm/yyyy"
                                                clearable
                                                disabled
                                            >
                                            </v-date-input>
 
                                            <v-text-field
                                                label="Mobile"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_mobile.value.value"
                                                :error-messages="employee_mobile.errorMessage.value"
                                                autocomplete="off"
                                                input-format="dd/mm/yyyy"
                                                clearable
                                                disabled
                                            >
                                            </v-text-field>
                                            
                                        </v-col>
                                        
                                        <v-col lg="4" md="4" cols="12">
                                            <v-text-field
                                                label="Email"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_email.value.value"
                                                :error-messages="employee_mobile.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                                disabled
                                            >
                                            </v-text-field>

                                            <v-text-field
                                                label="Slab"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_slab.value.value"
                                                :error-messages="employee_slab.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                                disabled
                                            >
                                            </v-text-field>

                                            <v-autocomplete
                                                label="Employee Type"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_type_id.value.value"
                                                :items="getHrmEmployeeTypeList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="employee_type_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                                disabled
                                            >
                                            </v-autocomplete>

                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-model="panel" class="mt-4">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4"  class="panel-header">Add Nominee </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit" ref="addEmployee" id="addEmployee">
                                    
                                    <v-row class="pa-2">
                                        
                                        <v-col lg="4" md="4" cols="12">
                                            
                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="name.value.value"
                                                :error-messages="name.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="father_name.value.value"
                                                :error-messages="father_name.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Father's Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template> 
                                            </v-text-field> 
                                            
                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="mother_name.value.value"
                                                :error-messages="mother_name.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Mother's Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field> 

                                            <v-text-field
                                                label="Relation"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="relation.value.value"
                                                :error-messages="relation.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>

                                            <v-date-input
                                                prepend-inner-icon="mdi-calendar"
                                                prepend-icon=""
                                                label="Date of Birth"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="date_of_birth.value.value"
                                                :error-messages="date_of_birth.errorMessage.value"
                                                autocomplete="off"
                                                input-format="dd/mm/yyyy"
                                                clearable
                                            >
                                                <template #label>
                                                    Date of Birth
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>  

                                            <v-text-field
                                                label="Percentage"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="percentage.value.value"
                                                :error-messages="percentage.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>
                                        </v-col>  

                                        <v-col lg="4" md="4" cols="12">
                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="national_id.value.value"
                                                :error-messages="national_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    National ID
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-autocomplete
                                                label="Blood Group"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="blood_group_id.value.value"
                                                :items="getBloodGroup"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="blood_group_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>

                                            <v-text-field
                                                label="Nationality"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="nationality.value.value"
                                                :error-messages="nationality.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Nationality
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field> 

                                            <v-autocomplete
                                                label="Religion"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="religion_id.value.value"
                                                :items="getHrmReligionList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="religion_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                            </v-autocomplete>

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="mobile.value.value"
                                                :error-messages="mobile.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Mobile No
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="email.value.value"
                                                :error-messages="email.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Email
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field> 
                                        </v-col>
                                        
                                        <v-col lg="4" md="4" cols="12"> 

                                            <v-text-field
                                                label="Occupation"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="occupation.value.value"
                                                :error-messages="occupation.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field> 

                                            <v-text-field
                                                label="Address"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="address.value.value"
                                                :error-messages="address.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field> 

                                            <v-file-input
                                                v-model="selectedImage"
                                                label="Select an Image"
                                                accept="image/*"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                show-size
                                                @input="previewImage"                               
                                                @click:clear="clearImage"
                                                class="ellipsis-filename"
                                                title="image"
                                            >                                                                                                  
                                            </v-file-input>
                                            <div class="float-right">
                                                <v-img  :src="preview" cover  class="preview-image"></v-img>
                                            </div>
                                        </v-col> 
                                    </v-row>
                                    <v-col cols="12" class="d-flex justify-end">
                                        <v-checkbox
                                            :true-value="1"
                                            :false-value="0"
                                            v-model="status.value.value"
                                            label="Active"
                                            color="primary"
                                        ></v-checkbox>  

                                        <input v-model="employee_id.value.value" type="hidden">
                                    </v-col>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-layout class="justify-end">
                                            <v-btn class="bg-red" variant="flat" type="reset">Reset</v-btn>
                                            <v-btn 
                                                class="bg-brand w-15 ms-2"  
                                                variant="flat" 
                                                type="submit"
                                            >
                                            {{ buttonText }}
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import formattedDate from '@/plugins/dateFormatter';
import { useRouter } from 'vue-router';
import { fileServerUrl } from "@/store/api";

export default {
        components: {
        },
        data: () => ({
            panel: [0],
            panel1: [0],
            loading:false,
            errorMessages:'',
            visible: false,
            search: "",
            selectedImage: null,
            photo_imageFile:'',
            preview: '/src/assets/no_preview.png',
        }),
        watch: {
        },
        created(){
            this.loading = true;
            Promise.all([
                this.$store.getters.getHrmEmployeeList.length === 0 ? this.$store.dispatch('getHrmEmployeeList') : Promise.resolve(),
                this.$store.getters.getHrmDepartmentList.length === 0 ? this.$store.dispatch('getHrmDepartmentList') : Promise.resolve(),
                this.$store.getters.getHrmDesignationList.length === 0 ? this.$store.dispatch('getHrmDesignationList') : Promise.resolve(),
                this.$store.getters.getHrmEmployeeTypeList.length === 0 ? this.$store.dispatch('getHrmEmployeeTypeList') : Promise.resolve(),
                this.$store.getters.getHrmBloodGroupList.length === 0 ? this.$store.dispatch('getHrmBloodGroupList') : Promise.resolve(),
                this.$store.getters.getHrmReligionList.length === 0 ? this.$store.dispatch('getHrmReligionList') : Promise.resolve(),
            ]).then(() => {
                this.loading = false;
            }).catch((error) => {
                this.loading = false;
                console.error('Error loading data:', error);
            });
        },
        computed:{
            getHrmEmployeeList() {
                return this.$store.getters.getHrmEmployeeList;
            },
            getHrmDesignationList() {
                return this.$store.getters.getHrmDesignationList;
            },
            getHrmDepartmentList() {
                return this.$store.getters.getHrmDepartmentList;
            },
            getHrmEmployeeTypeList() {
                return this.$store.getters.getHrmEmployeeTypeList;
            },
            getBloodGroup() {
                return this.$store.getters.getHrmBloodGroupList;
            },
            getHrmReligionList() {
                return this.$store.getters.getHrmReligionList;
            },
        },
        methods: {
            editItem(item){
                
                this.status.value.value = item.status;
                this.employee_id.value.value = item.id;
            },
            async onEmployeeChange(selectedId) {
                if (!selectedId) {
                    this.employee_name.value.value = "";
                    this.employee_department_id.value.value = null;
                    this.employee_designation_id.value.value =  null;
                    this.employee_joining_date.value.value = "";
                    this.employee_mobile.value.value = "";  
                    this.employee_email.value.value = "";
                }

                try {
                    const response = await this.$store.dispatch(
                        "getEmployeeDetails",
                        selectedId
                    );
                    console.log(response.data.data)
                    const employee = response.data.data;
                    this.employee_name.value.value = employee.name || "";
                    this.employee_department_id.value.value = employee.department_id || "";
                    this.employee_designation_id.value.value = employee.designation_id || "";
                    this.employee_joining_date.value.value = employee.joining_date || "";
                    this.employee_mobile.value.value = employee.mobile || "";  
                    this.employee_email.value.value = employee.email || "";
                    this.employee_type_id.value.value = employee.employee_type_id || "";
                    this.$store.commit("UNSET_LOADING");
                } catch (error) {
                    console.log(error);
                }
            },
            previewImage: function(event) {
                this.selectedImage = event.target.files[0];
                const input = event.target;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                        this.preview = e.target.result;
                    }
                    this.image = input.files[0];
                    reader.readAsDataURL(input.files[0]);
                }
                else {
                    this.preview = '/src/assets/no_preview.jpeg';
                }
            },
            clearImage() {
                this.preview = '/src/assets/no_preview.png';
            },
        },
        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    name: yup.string().required('Name is required'),
                    father_name: yup.string().required('Father\'s Name is required'),
                    mother_name: yup.string().required('Mother\'s Name is required'),   
                    national_id: yup.string().required('National ID is required'),
                    date_of_birth: yup.date().required('Date of Birth is required'),
                    nationality: yup.string().required('Nationality is required'), 
                    mobile: yup.string().min(8).max(18).required('Mobile No is required'),
                    email: yup.string().email('Invalid email format').required('Email is required'),
                    employee_id: yup.string().required('Employee is required'),
                }),

            });

            const nominee_id = useField('nominee_id');
            const name = useField('name');
            const mobile = useField('mobile');
            const employee_type_id = useField('employee_type_id');
            const gender_id = useField('gender_id');
            const blood_group_id = useField('blood_group_id');
            const religion_id = useField('religion_id');
            const national_id = useField('national_id');
            const status = useField('status');
            const user_id = useField('user_id');
            const employee_id = useField("employee_id");
            const employee_name = useField('employee_name');
            const employee_department_id = useField('employee_department_id');
            const employee_designation_id = useField('employee_designation_id');
            const address = useField('address');
            const nationality = useField('nationality');
            const date_of_birth = useField('date_of_birth');
            const employee_joining_date = useField('employee_joining_date');
            const employee_mobile = useField('employee_mobile');
            const employee_email = useField('employee_email');
            const employee_slab = useField('employee_slab');
            const father_name = useField('father_name');
            const mother_name = useField('mother_name');
            const email = useField('email');

            const relation = useField('relation');
            const percentage = useField('percentage');
            const occupation = useField('occupation');

            const selectedImage  = ref(null);
            const errorMessages  = ref('');
            const loading  = ref('');
            const buttonText  = ref('');
            buttonText.value = 'Save';
            const store = useStore();
            const router = useRouter();
            const submit = handleSubmit((values) => {

                values.date_of_birth = formattedDate(date_of_birth.value.value);
                values.employee_joining_date = formattedDate(employee_joining_date.value.value);
                const formData = new FormData();
                Object.keys(values).forEach((key) => { formData.append(key, values[key] || '')});

                if (selectedImage.value) {
                    formData.append('image', selectedImage.value); 
                }
                formData.append('status', status.value.value ? 1 : 0);
                console.log(values)
                store.dispatch("saveUpdateHrmNominee", formData)
                    .then((response) => {
                        buttonText.value = 'Save';
                        resetForm();
                        toast.success(response.data.message, {
                            timeout: 3000,
                        });
                        setTimeout(() => {
                            store.dispatch("getHrmNomineeList").then(() => {
                                router.push({ path: "nominee-list" });
                            });
                        }, 2000);
                    })
                    .catch((error) => {    
                        console.log(error.response.data.message);       
                        toast.error(error.response.data.message);          
                    })
            });
            
            return {
                submit,
                nominee_id,
                name,
                mobile,
                national_id,
                employee_type_id,
                gender_id,
                blood_group_id,
                religion_id,
                address,
                email,
                date_of_birth,
                employee_joining_date,
                nationality,
                father_name,
                mother_name,
                relation,
                percentage,
                occupation,
                status,
                errorMessages,
                selectedImage,
                user_id,
                employee_name,
                employee_id,
                employee_department_id,
                employee_designation_id,
                employee_mobile,
                employee_email,
                employee_slab,
                buttonText,
                loading
            }
        },
        mounted() {
            if (this.$store.getters.getEditingNominee) {
                const nominee = this.$store.getters.getEditingNominee;
                this.nominee_id.value.value = nominee.id;
                this.employee_id.value.value = nominee.employee_id;
                this.name.value.value = nominee.name;
                this.mobile.value.value = nominee.mobile;
                this.national_id.value.value = nominee.national_id;
                this.employee_type_id.value.value = nominee.employee_type_id;
                this.employee_department_id.value.value = nominee.employee_department_id;
                this.employee_designation_id.value.value = nominee.employee_designation_id;
                this.gender_id.value.value = nominee.gender_id;
                this.blood_group_id.value.value = nominee.blood_group_id;
                this.religion_id.value.value = nominee.religion_id;
                this.address.value.value = nominee.address;
                this.percentage.value.value = nominee.percentage;
                this.employee_slab.value.value = nominee.employee_slab;
                this.employee_name.value.value = nominee.employee_name;
                this.employee_email.value.value = nominee.employee_email;
                this.employee_mobile.value.value = nominee.employee_mobile;
                this.relation.value.value = nominee.relation;
                this.occupation.value.value = nominee.occupation;
                this.email.value.value = nominee.email;
                this.date_of_birth.value.value = nominee.date_of_birth;
                this.employee_joining_date.value.value = nominee.employee_joining_date;
                this.nationality.value.value = nominee.nationality;
                this.father_name.value.value = nominee.father_name;
                this.mother_name.value.value = nominee.mother_name;
                this.status.value.value = nominee.status === 1 ? 1 : 0;
                if (nominee.image) {
                    this.image
                    this.preview = fileServerUrl +nominee.image;
                }else{
                    this.preview = '/src/assets/no_preview.png';
                }

                this.buttonText = 'Update';
                return;
            }else {
                this.nationality.value.value = 'Bangladeshi';
                this.employee_designation_id.value.value = null;
                this.employee_department_id.value.value = null;
            }
        },  
        beforeUnmount() {
            this.$store.commit("setEditingNominee", null);
        }
    }
</script>
